import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaLock, FaArrowLeft } from 'react-icons/fa';

const UnauthorizedContainer = styled.div`
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: ${props => props.theme.colors.background};
`;

const ErrorCard = styled.div`
  background: ${props => props.theme.colors.surface};
  border-radius: 15px;
  padding: 3rem;
  text-align: center;
  box-shadow: 0 4px 20px ${props => props.theme.colors.shadow};
  max-width: 500px;
  width: 100%;
`;

const LockIcon = styled.div`
  color: ${props => props.theme.colors.primary};
  font-size: 4rem;
  margin-bottom: 1.5rem;
`;

const Title = styled.h1`
  color: ${props => props.theme.colors.text};
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  color: ${props => props.theme.colors.textSecondary};
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const BackButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: ${props => props.theme.colors.primary};
  color: white;
  padding: 1rem 2rem;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    background: ${props => props.theme.colors.primaryDark};
  }
`;

const Unauthorized = () => {
  return (
    <UnauthorizedContainer>
      <ErrorCard>
        <LockIcon>
          <FaLock />
        </LockIcon>
        <Title>Access Denied</Title>
        <Message>
          You don't have permission to access this page. 
          This area is restricted to authorized users only.
        </Message>
        <BackButton to="/">
          <FaArrowLeft />
          Back to Home
        </BackButton>
      </ErrorCard>
    </UnauthorizedContainer>
  );
};

export default Unauthorized;